module.exports = __webpack_public_path__ + "img/bg-sildbar.2158ebfd.png";